module.exports = __webpack_public_path__ + "static/media/about-3.3b09e68c.jpg";